import { projects, isLinkable } from './data/projects.js';
import { meta as homeMeta } from './pages/HomePage.jsx';
import { meta as processMeta } from './pages/ProcessPage.jsx';
import { meta as projectsMeta } from './pages/ProjectsPage.jsx';
import { meta as aboutMeta } from './pages/AboutPage.jsx';
import { meta as contactMeta } from './pages/ContactPage.jsx';
import { meta as notFoundMeta } from './pages/NotFoundPage.jsx';
import { metaFor as projectMetaFor } from './pages/ProjectDetailPage.jsx';

/**
 * Every URL the site has, with the metadata that belongs to it.
 *
 * One list, used twice: the prerender script walks it to decide which HTML
 * files to write and what to put in each <head>, and the client reads the
 * same entries to keep the title correct across in-app navigation. Adding a
 * page means adding it here and nowhere else.
 */
export const routes = [
  { path: '/', meta: homeMeta },
  { path: '/process', meta: processMeta },
  { path: '/projects', meta: projectsMeta },
  { path: '/about', meta: aboutMeta },
  { path: '/contact', meta: contactMeta },
  ...projects.filter(isLinkable).map((project) => ({
    path: `/projects/${project.slug}`,
    meta: projectMetaFor(project.slug),
  })),
  { path: '/404', meta: notFoundMeta },
];

/**
 * Trailing slashes are normalised away before matching. A static host that
 * serves `/about/index.html` will happily answer `/about/` too, and React
 * Router matches that route either way — but a raw string comparison here
 * would not, and the page would silently pick up the 404 title.
 */
const normalise = (pathname) =>
  pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;

export const findRoute = (pathname) => {
  const target = normalise(pathname);
  return routes.find((route) => route.path === target);
};
